module.exports = __webpack_public_path__ + "static/media/LTC-icon.7bd7ceeb.svg";